import React, { useRef, useEffect } from "react";
import { Input } from "antd";
import { BarcodeOutlined } from "@ant-design/icons";

const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
const ScanInput = ({ onValueChange, value, placeholder, size, length, onBlur, autoFocus }) => {
  const bufferRef = useRef("");
  const timerRef = useRef(null);
  const inputRef = useRef(null);
  const isFocusedRef = useRef(false);

  useEffect(() => {
    if (isMobile) return;

    const handleKeyDown = (event) => {
      if (!isFocusedRef.current) return;

      if (event.key === "Enter") {
        if (bufferRef.current.length > 0) {
          onValueChange?.(bufferRef.current, true);
          bufferRef.current = "";
        }
      } else if (event.key !== "Shift") {
        bufferRef.current += event.key;
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => (bufferRef.current = ""), 300);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onValueChange]);

  const handleChange = (e) => {
    onValueChange?.(e.target.value, false);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Input
        ref={inputRef}
        onFocus={() => (isFocusedRef.current = true)}
        onBlur={(e) => {
          isFocusedRef.current = false;
          onBlur?.(e);
        }}
        value={value || ""}
        onChange={handleChange}
        placeholder={placeholder || "Scan barcode here"}
        style={{ width: length || "260px" }}
        size={size || "medium"}
        autoFocus
        prefix={<BarcodeOutlined style={{ fontSize: 23 }} />}
      />
    </div>
  );
};

export default ScanInput;
